import React from 'react';
import { DateTime, Duration } from 'luxon';
import { Row, Col } from 'react-bootstrap';
import { RichText } from 'prismic-reactjs';
import Layout from '../components/Layout';
import OpenGraphTitle from '../components/OpenGraphTitle';
import OpenGraphDescription from '../components/OpenGraphDescription';
import Head from '../components/head';
import Section from '../components/Section';
import PageTitle from '../components/PageTitle';
import SwooptyBg from '../components/SwooptyBg';
import { FranchiseeProvider } from '../context/Franchisee';
import { PrismicClient } from '../SDKs/Prismic/prismic.config';
import htmlSerializer from '../SDKs/Prismic/htmlSerializer';

export const getStaticProps = async (context) => {
  const { req } = context;
  const accessibility = await PrismicClient(req).getSingle(
    'accessibility',
    {}
  );
  const revalidate = Duration.fromObject({ days: 1 }).as('seconds');

  return {
    props: {
      accessibility,
    },
    revalidate,
  };
};

interface AccessibilityPageProps {
  /* add privacy policy page props here */
  accessibility: any;
}

const Accessibility: React.FC<AccessibilityPageProps> = ({
  accessibility,
}: AccessibilityPageProps) => {
  const lastUpdated = DateTime.fromISO(accessibility.last_publication_date);

  const { content } = accessibility.data;
  return (
    <FranchiseeProvider>
      <Layout alternateFooter>
        <Head
          slug='accessibility'
          title='Accessibility - Two Maids Cleaning Services'
          description={`Two Maids is committed to ensuring equal access for people with disabilities and we work to maximize access to this website.`}
        />
        <OpenGraphTitle title='Accessibility - Two Maids Cleaning Services' />
        <OpenGraphDescription>
          Two Maids is committed to ensuring equal access for people with disabilities and we work to maximize access to this website.
        </OpenGraphDescription>
        <Section>
          <Row className='justify-content-center'>
            <Col xs={12} lg={10} xl={9}>
              <div className='mb-3'>
                <PageTitle>Accessibility</PageTitle>
                <span className='text-uppercase font-weight-bold'>
                  Last Updated {lastUpdated.toLocaleString(DateTime.DATE_FULL)}
                </span>
              </div>
              <RichText render={content} htmlSerializer={htmlSerializer} />
            </Col>
          </Row>
        </Section>
      </Layout>
    </FranchiseeProvider>
  );
};

export default Accessibility;
